import React from 'react';
import useLiveValue from '../useLiveValue';

const CONDITIONS = {
    clear: { icon: 'fas fa-sun', label: 'Clear' },
    cloudy: { icon: 'fas fa-cloud', label: 'Cloudy' },
    rain: { icon: 'fas fa-cloud-rain', label: 'Rain' },
};

const WeatherWidget = ({ config }) => {
    const { dataSource = {}, settings = {} } = config;
    const condition = CONDITIONS[dataSource.condition] || CONDITIONS.clear;
    const temp = useLiveValue(settings.value ?? 0, { id: config.id, min: 15, max: 45, volatility: 0.02 });
    const humidity = dataSource.humidity ?? 0;
    const wind = dataSource.wind ?? 0;

    return (
        <div className="weather-widget" title={`${condition.label}, ${temp.toFixed(1)}°C`}>
            <div className="weather-widget__main">
                <i className={`${condition.icon} weather-widget__icon`}></i>
                <div className="weather-widget__temp">{temp.toFixed(1)}°C</div>
            </div>
            <div className="weather-widget__stats">
                <div className="weather-widget__stat">
                    <i className="fas fa-droplet"></i>
                    <span>{humidity}%</span>
                </div>
                <div className="weather-widget__stat">
                    <i className="fas fa-wind"></i>
                    <span>{wind} km/h</span>
                </div>
            </div>
        </div>
    );
};

export default WeatherWidget;
